module.exports = __webpack_public_path__ + "img/mach-logo.a5699487.png";